import React, {useState, useEffect} from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { phpPath } from "./config"; // adjust path if needed

const Store = () => {

    const imagePath = "/images/products/";

    const [pageNumber, setPageNumber] = useState(1); // #added 4/4/25 TG
    const [itemsPerPage, setItemsPerPage] = useState(12); // #added 4/4/25 TG
    const [display, setDisplay] = useState("items"); // #added 4/4/25 TG
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [products, setProducts] = useState([]); // #added 4/4/25 TG

    // #state

    /*const products = [
      {
        product_id: 1,
        name: "Kettlebell",
        mainImage: `${imagePath}kettlebell-1.png`,
        images: [
          `${imagePath}kettlebell-1.png`,
          `${imagePath}kettlebell-2.png`,
          `${imagePath}kettlebell-3.png`,
        ],
        price: "$49.99",
        stock: 10,
        description: `
          <p><strong>A high-quality kettlebell</strong> for strength training.</p>
          <ul>
            <li>Ergonomic grip</li>
            <li>Rust-resistant finish</li>
            <li>Available in multiple weights</li>
          </ul>
          <p>💪 Perfect for beginners and pros alike.</p>
        `,
      },
      {
        product_id: 2,
        name: "Dumbbell",
        mainImage: `${imagePath}dumbbells-1.png`,
        images: [
          `${imagePath}dumbbells-1.png`,
          `${imagePath}dumbbells-2.png`,,
          `${imagePath}dumbbells-3.png`,
        ],
        price: "$29.99",
        stock: 5,
        description: `
          <p><strong>Adjustable dumbbells</strong> designed for compact home gyms.</p>
          <p>Features:</p>
          <ol>
            <li>Quick-lock system</li>
            <li>Rubber-coated handles</li>
            <li>Up to 25 lbs each</li>
          </ol>
        `,
      },
      {
        product_id: 3,
        name: "Musculos",
        mainImage: `${imagePath}muscles-1.png`,
        images: [
          `${imagePath}muscles-1.png`,
          `${imagePath}muscles-2.png`,
          `${imagePath}muscles-3.png`,
        ],
        price: "$29.99",
        stock: 20,
        description: `
          <p>Premium resistance bands to build muscle.</p>
          <p><em>Includes light, medium, and heavy options</em>.</p>
        `,
      },
    ];*/
    

    const fetchProductDetails = (product_id) => {
      const product = products.find(p => p.product_id === product_id);
      if (product) {
        setSelectedProduct(product);
        setSelectedImage(product.mainImage); // 🆕
        setDisplay('product');
      }
    };
    
  
    const handleBack = () => {
      setDisplay('items');
      setSelectedProduct(null);
    };
  
    useEffect(() => {
      const fetchProducts = async () => {
        try {
          const res = await fetch(`${phpPath}/get_products.php`, {
            method: 'POST'
          });
          const data = await res.json();
          setProducts(data);
        } catch (err) {
          console.error("Error fetching products:", err);
        }
      };
    
      fetchProducts();
    }, []);

    //------------------------------------
    // JSX
    //------------------------------------
    return (
      <div>
        <main>
          <AnimatePresence mode="wait">
            {/* #Items List */}
            {display === "items" && (
              <motion.div
                key="items-view"
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 40 }}
                transition={{ duration: 0.4 }}
              >
                <section id="store" className="section overlay tint-black-30 height-40vh">
                  <div className="section__content">
                    <h2 className="general-title">Store</h2>
                    <h2 className="font-size-20 color-gray-3">
                      gear up and get ripped!
                    </h2>
                  </div>
                </section>
    
                <section className="section-2 bg-image-floor overlay tint-black-50">
                  <div className="section__content">
                    <div className="store-box-container">
                      {products.map((product) => (
                        <div
                          key={product.product_id}
                          className="store-box"
                          onClick={() => fetchProductDetails(product.product_id)}
                        >
                          <div className="store-box-image-container">
                            <img
                              src={product.images[0]}
                              alt={product.name}
                              className="store-box-image"
                            />
                          </div>
                          <span className="store-box-name">{product.name}</span>
                          <span className="store-box-price">{product.price}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </section>
              </motion.div>
            )}
    
            {/* Single Product Detail View */}
            {display === "product" && selectedProduct && (
              <motion.div
                key="product-view"
                className="product-detail"
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -40 }}
                transition={{ duration: 0.4 }}
              >
                <button onClick={handleBack} className="back-button">
                  ← Back to Products
                </button>
                <div className="product-detail-container">
                  <img
                    src={selectedImage}
                    alt={selectedProduct.name}
                    className="product-detail-image"
                  />
                  <div className="product-thumbnails">
                    {selectedProduct.images.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`Thumbnail ${index + 1}`}
                        className={`thumbnail-image ${img === selectedImage ? 'selected' : ''}`}
                        onClick={() => setSelectedImage(img)}
                      />
                    ))}
                  </div>
          

                  <div className="product-detail-content">
                    <h2 className="product-detail-name">{selectedProduct.name}</h2>
                    <p className="product-detail-price">{selectedProduct.price}</p>
                    <p className="product-detail-stock">
                      In stock: {selectedProduct.stock}
                    </p>
                    <div
                      className="product-detail-description"
                      dangerouslySetInnerHTML={{ __html: selectedProduct.description }}
                    ></div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </main>
      </div>
    );
    
};

export default Store;